module.exports = __webpack_public_path__ + "static/fonts/iconfont.0960cbb.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.ttf?t=1683809780211
// module id = z5Jf
// module chunks = 44